<template>
	<article class="p-6 lg:p-12 flex gap-6 group items-start border-b border-grey -mb-px">
		<figure class="relative basis-[100px] md:basis-[40%] shrink-0">
			<a :href="item.permalink" class="block w-full aspect-square !bg-gray-100 relative">
				<Image :src="item.post_thumbnail" class="w-full h-full object-cover absolute" />
				<!-- <img class="w-full h-full object-cover absolute" :src="item.post_thumbnail" /> -->
			</a>
			<Tags :tags="item.event_availability_tags" :sold-out="isSoldOut" />
		</figure>
		<div class="grid gap-2">
			<div class="uppercase flex items-center gap-2 flex-wrap leading-none">
				<span>{{ item.event_start_date }}</span>
				<span class="size-1 bg-black rounded-full block"></span>
				<span>{{ item.event_start_time }}</span>
			</div>
			<p class="font-header uppercase text-lg leading-none m-0!"><a :href="item.permalink" class="text-black hover:!text-blue hover:!underline hover:!decoration-1">{{ item.post_title }}</a></p>
			
			<div v-if="item.venue">
				<span class="tag flex gap-1 items-center" :class="venueClass">
					<MapPinIcon class="size-4" aria-hidden="true" />
					<span class="inline-flex font-bold text-sm ml-1">{{ item.venue.name }}</span>
				</span>
			</div>

			<span class="leading-tight uppercase" v-html="item.event_excerpt"></span>

			<div class="flex gap-2 items-center mt-2">
				<a :href="item.permalink" class="uppercase py-1 px-3 border border-grey rounded-3xl hover:!bg-blue hover:!text-white hover:border-blue">Info</a>
				<a :href="item.event_buy_link" v-show="item.event_buy_link && !item.event_sold_out" class="uppercase py-1 px-3 border border-grey rounded-3xl hover:!bg-blue hover:!text-white hover:border-blue">{{ item.event_buy_text }}</a>
				<span v-show="isFree" class="uppercase py-1 px-3 bg-blue border border-blue before:hidden! rounded-3xl text-white">Free</span>
				<span v-show="isSoldOut" class="uppercase py-1 px-3 sold-out border border-red rounded-3xl">Sold out</span>
			</div>
		</div>
	</article>
</template>

<script setup>
import { computed } from "vue";
import { MapPinIcon } from "@heroicons/vue/20/solid";
import Tags from '@facet/global/Tags.vue';
import Image from "../../global/Image.vue";

const { item } = defineProps({
	item: {
		type: Object,
		required: true,
	},
});

const isSoldOut = computed(() => {
	return Boolean( Number(item.event_sold_out) );
})

const isFree = computed(() => {
	return Boolean( Number(item.event_is_free) );
})

const venueClass = computed(() => {

	return `mstag-${ item.venue.slug}`;

	// const map = {
	// 	"Main Venue": "venue-venue",
	// 	"The Copper Bar": "venue-copper",
	// };

	// return map[item.event_venue] ?? "";
})

</script>
